export const environment = {
  appUrl: 'https://pkkapi.goagro.ru/api/', // real
  // appUrl: 'http://192.168.0.106:9710/api/', // test
  // appUrl: 'https://cadastralapidev.innline.am/api/', // test
  production: false,
};
